import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useServices, useStores } from "index";
import { useNavigate } from "react-router-dom";
import { AdminPagesRelativeRoutes } from "Routes";
import { getErrorMessage } from "utilities/ErrorHelper";

type Callbacks = {
  onSuccess?: () => Promise<void> | void;
};

export const useDeleteOrganization = (callbacks?: Callbacks) => {
  const organizationsEditorService = useServices().organizationsEditorService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (id: string) => organizationsEditorService.deleteOrganization(id),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['adminOrganizationsList'] }),
        queryClient.invalidateQueries({ queryKey: ['organizationsList'] }),
      ]);
      notificationsStore.addToast('success', 'Organization has been deleted successfully', 'success');
      await callbacks?.onSuccess?.();
      navigate(`/Admin/${AdminPagesRelativeRoutes.OrganizationsList}`);
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};